import { render } from "./Form.vue?vue&type=template&id=3e89b3f2"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=3e89b3f2&lang=css"
script.render = render

export default script